import type { SignupPlanId } from "./components/AuthEntryShell";

export const PENDING_SIGNUP_PLAN_STORAGE_KEY = "management-tool.pendingSignupPlan";
export const PENDING_SIGNUP_RETURN_TO_STORAGE_KEY = "management-tool.pendingSignupReturnTo";
export const PENDING_SIGNUP_USER_ID_STORAGE_KEY = "management-tool.pendingSignupUserId";

export const clearPendingSignupRecovery = (): boolean => {
  try {
    window.sessionStorage.removeItem(PENDING_SIGNUP_USER_ID_STORAGE_KEY);
    window.sessionStorage.removeItem(PENDING_SIGNUP_PLAN_STORAGE_KEY);
    window.sessionStorage.removeItem(PENDING_SIGNUP_RETURN_TO_STORAGE_KEY);
    return true;
  } catch {
    return false;
  }
};

export const rememberPendingSignupRecovery = (
  userId: string,
  plan: SignupPlanId,
  returnPath: string
): boolean => {
  if (!clearPendingSignupRecovery() || !userId) return false;
  try {
    window.sessionStorage.setItem(PENDING_SIGNUP_PLAN_STORAGE_KEY, plan);
    window.sessionStorage.setItem(PENDING_SIGNUP_RETURN_TO_STORAGE_KEY, returnPath);
    window.sessionStorage.setItem(PENDING_SIGNUP_USER_ID_STORAGE_KEY, userId);
    return true;
  } catch {
    clearPendingSignupRecovery();
    return false;
  }
};

export const getStoredValue = (key: string): string | null => {
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
};
